import { render, staticRenderFns } from "./CruiseDetailPolicy.vue?vue&type=template&id=333e4b1a&scoped=true"
import script from "./CruiseDetailPolicy.vue?vue&type=script&lang=js"
export * from "./CruiseDetailPolicy.vue?vue&type=script&lang=js"
import style0 from "./CruiseDetailPolicy.vue?vue&type=style&index=0&id=333e4b1a&prod&lang=less&scoped=true"
import style1 from "./CruiseDetailPolicy.vue?vue&type=style&index=1&id=333e4b1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333e4b1a",
  null
  
)

export default component.exports